import axios from 'axios';
import Router from '../router';
import baseconfig from './beasconfig.js';
import { showToastMsg } from './message';
axios.defaults.baseURL = baseconfig.baseUrlapi;
// axios.defaults.withCredentials = true;
// axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
// axios.defaults.headers['token'] = localStorage.getItem('token') || ''
axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.timeout = "100000";

//get请求
const GET = (url, params, type) => {
  var allapiurl = getUrl(url, type);
  return axios.get(`${allapiurl}`, { params: params }).then(res => res.data)
}

//post请求
const POST = (url, params, type, config) => {
  var allapiurl = getUrl(url, type);
  if (config == '') {
    return axios.post(`${allapiurl}`, params).then(res => res.data)
  } else {
    return axios.post(`${allapiurl}`, params, config).then(res => res.data)
  }

}

//put请求
const PUT = (url, params, type) => {
  var allapiurl = getUrl(url, type);
  return axios.put(`${allapiurl}`, params).then(res => res.data)
}

//patch请求
const PATCH = (url, params, type) => {
  var allapiurl = getUrl(url, type);
  return axios.patch(`${allapiurl}`, params).then(res => res.data)
}

//del请求
const DELETE = (url, params, type) => {
  var allapiurl = getUrl(url, type);
  return axios.delete(`${allapiurl}`, {
    data: params
  }).then(res => res.data)
}

//封装api接口
const getUrl = (url, type) => {
  let allapiurl = baseconfig.baseUrlapi;
  if (type == 1) {
    allapiurl = "";
  } else {
    allapiurl = baseconfig.baseUrlapi
  }
  return allapiurl + url;
}

axios.interceptors.response.use(
  response => {
    if (response.data.code == 40102) {
      Router.push("/");
      sessionStorage.removeItem("loginInfo")
      // break;
      return
    }
    return response;
  },
  error => {
    let url = error.response.config.url;
    let $t = window.$t;
    if (error.response) {
      switch (error.response.status) {
        case 40402:
          // 这里写清除token的代码
          sessionStorage.removeItem("loginInfo");
          showToastMsg($t('message.Logintimedout'))
          Router.push("/");
          break;
        default:
          if (url.indexOf('googleapis') >= 0) {
            console.log('谷歌地图查询地址错误')
            // showToastMsg($t('message.Serverconnectionexception'))
          } else {
            showToastMsg($t('message.Serverconnectionexception'))
            Router.push("/");
          }
      }
    }
    return error
  });

// axios.interceptors.response.use(res => {
//   response => {
//     console.log(res, response)
//     if (response.data.code == 40102) {
//       Router.push("/");
//       sessionStorage.removeItem("loginInfo")
//       // break;
//       return
//     }
//     return response;
//   },
//     error => {
//       // console.log(error)
//       if (error.response) {
//         switch (error.response.status) {
//           case 40402:
//             // 这里写清除token的代码
//             sessionStorage.removeItem("loginInfo");
//             showFailToast("登录超时！", 'warning')
//             Router.push("/");
//             break;
//           default:
//             showFailToast("服务器连接异常");
//           // Router.push("/login");
//         }
//       }
//       // return Promise.reject(error.response.data)
//     }
//   return res.data
// })

export default {
  GET,
  POST,
  PUT,
  PATCH,
  DELETE
}

